import * as ActionTypes from 'state/types'
import * as Selectors from 'state/selectors'
import Routes from 'shared/utils/api/routes'

export const savePause = () => ({

  type: ActionTypes.SAVE_PAUSES_PREPARE,
  provideResponse: false,
  provideParentPayload: false,
  payload: {
    url: Routes.PAUSE_SAVE_ROUTE,
    method: 'post'
  },
  meta: {
    finalActionType: ActionTypes.SAVE_PAUSES_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getActiveAgentId,
        deepLevel:['data'],
        key: 'agentId'
      },
      {
        selector: Selectors.getSelectedInteractionThreadIds,
        deepLevel:['data'],
        key: 'threads'
      }
    ]
  }
})
export const deletePause = () => ({

  type: ActionTypes.DELETE_PAUSES_PREPARE,
  provideResponse: false,
  provideParentPayload: false,
  payload: {
    url: Routes.PAUSE_REMOVE_ROUTE,
    method: 'delete'
  },
  meta: {
    finalActionType: ActionTypes.DELETE_PAUSES_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getActiveAgentId,
        deepLevel:['data'],
        key: 'agentId'
      },
      {
        selector: Selectors.getSelectedInteractionThreadIds,
        deepLevel:['data'],
        key: 'threads'
      }
    ]
  }
})

export const receiveUpdatedPause = (pause) => ({
  type: ActionTypes.RECEIVE_UPDATED_PAUSE,
  pause
})

export const receiveDeletedPause = (pause) => ({
  type: ActionTypes.RECEIVE_DELETED_PAUSE,
  pause
})
